import moment from 'moment'
import 'moment/locale/ja'

moment.defineLocale('ja-review', {
  parentLocale: 'ja',
  relativeTime: {
    s: '%d秒'
  }
})

const roundRating = (count) => {
  if (isNaN(count) || count <= 0) {
    return 0
  }
  const intPart = Math.floor(count)
  const fractionPart = Math.round((count - intPart) * 10)
  if (fractionPart <= 2) {
    return intPart
  } else if (fractionPart >= 8) {
    return intPart + 1
  } else {
    return intPart + 0.5
  }
}
export const formatRating = (count) => {
  if (typeof count !== 'number') {
    return ''
  }
  return Array(Math.ceil(roundRating(count)) + 1).join('★')
}

export const formatRatingClassName = (count, prefix, suffix) => {
  return (prefix || '') + String(roundRating(count) * 10) + (suffix || '')
}

export const formatDate = (dateString) => {
  if (!dateString || typeof dateString !== 'string') {
    return ''
  }
  const date = moment(dateString + '+0900', 'YYYY-MM-DD HH:mm:ssZ', true)
  if (!date.isValid()) {
    return ''
  }
  return date.utcOffset('+0900').format('YYYY/MM/DD')
}

export const formatRelativeDate = (dateString) => {
  if (!dateString || typeof dateString !== 'string') {
    return ''
  }
  const date = moment(dateString + '+0900', 'YYYY-MM-DD HH:mm:ssZ', true)
  if (!date.isValid()) {
    return ''
  }
  const now = moment()
  const elapsed = moment.duration(Math.ceil(now.diff(date) / 1000), 's')
  if (elapsed.as('s') < 0 || elapsed.as('days') >= 3) {
    return date.utcOffset('+0900').format('YYYY/MM/DD')
  } else {
    moment.relativeTimeRounding(Math.floor)
    moment.relativeTimeThreshold('s', 60)
    moment.relativeTimeThreshold('m', 60)
    moment.relativeTimeThreshold('h', 24)
    if (elapsed.as('days') >= 1) {
      now.utcOffset('+0900').startOf('day')
      date.utcOffset('+0900').startOf('day')
    }
    return date.locale('ja-review').from(now)
  }
}

export const formatDateString = (dateString) => {
  if (!dateString || typeof dateString !== 'string') {
    return ''
  }
  const year = dateString.substring(0, 4)
  const manth = dateString.substring(4, 6)
  const day = dateString.substring(6, 8)
  return year + '/' + manth + '/' + day
}



// WEBPACK FOOTER //
// ./src/filters/formatter.js